module.exports = __webpack_public_path__ + "static/media/analytics.ca206d76.svg";